export const mockDetailedCandidate = {
    personal: {
      name: 'Jessica Martinez',
      title: 'Senior Full Stack Engineer',
      experience: 5,
      description: 'E-commerce specialist who built scalable React applications serving 2M+ users',
      avatar: 'https://randomuser.me/api/portraits/women/47.jpg',
      match: 96,
    },
    details: {
      company: 'Shopify Inc.',
      location: 'Toronto, Canada',
      nationality: 'Canadian',
      languages: ['English', 'Spanish', 'French'],
      gender: 'Female',
      phone: '+33 1 42 86 83 02',
      email: 'jessicamartinez@email.com',
      address: '47 Rue Saint-Denis, Paris',
      preference: 'On site',
      skills: ['React', 'JavaScript', 'Node.js', 'TypeScript'],
    },
    goodFit: [
      '5 years of experience in building scalable React applications for over 2M+ users.',
      'Skilled in both frontend and backend technologies (React, Node.js, TypeScript, JavaScript).',
      'Works at Shopify Inc., indicating strong experience in high-performance e-commerce platforms.',
      'Fluent in English, Spanish, and French – suitable for global team collaboration.',
      'Comfortable with on-site roles, which is ideal for hands-on engineering work and leadership.',
    ],
    screening: {
      questions: [
        'What scalable applications have you developed or contributed to, and what technologies did you use?',
        'How do you approach performance optimization in large-scale React applications?',
        'Have you worked on e-commerce platforms? If yes, describe the challenges and your role.',
        'What\'s your experience working with REST APIs or GraphQL in Node.js?',
        'Can you describe a time when you had to debug a complex issue in production?',
      ],
      gaps: [], // Placeholder for future data
      resume: [], // Placeholder for future data
    },
  };